import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import HeadlineSplit from '../../../UI/Headline/Split'
import LargeContainer from '../../../UI/Container/LargeContainer'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import Modal from '../../../UI/Modal/Modal'
import 'react-datetime/css/react-datetime.css'
import Button from '../../../UI/Button/Button'
import Forecast from '../Forecast/Forecast'
import AddOffer from '../AddOffer/AddOffer'
import YearSelector from '../../../UI/YearSelector/YearSelector'
import moment, { Moment } from 'moment'
import SelectKostenstelle from './SelectKostenstelle/SelectKostenstelle'
import useLoadControllingYearReport from '../../../hooks/Controlling/useLoadControllingYearReport'

const YearList: React.FC = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { kostenstelleUUID, companyUUID, year } = useParams()
  const [selectedYear, setSelectedYear] = useState<Moment | null>()
  const [showYearSelection, setShowYearSelection] = useState(false)
  const [yearReport, pull] = useLoadControllingYearReport(companyUUID, kostenstelleUUID)

  useEffect(() => {
    if (!selectedYear && !year) {
      const currentDate = new Date()
      setSelectedYear(moment(currentDate))
      pull(moment(currentDate).year())
    } else if (!selectedYear && year) {
      setSelectedYear(moment(year))
      pull(moment(year).year())
    }
  }, [selectedYear, year, pull])

  const toggleShowYearSelection = () => setShowYearSelection(!showYearSelection)

  const updateData = () => {
    pull(selectedYear?.year())
    setShowYearSelection(false)
  }

  if (!yearReport) return null
  return (
    <LargeContainer>
      <div className="flex flex-col gap-1 pt-2 pb-10 mt-10">
        <div className="flex items-center justify-between">
          <HeadlineSplit prefix={`${yearReport.company.name} - `} suffix={`${yearReport.kostenstelle.name}.`} />
          <div>
            <SelectKostenstelle yearMoment={selectedYear} />
          </div>
        </div>
        <div className="flex items-center gap-3 mt-10">
          {!!selectedYear && <Button onClick={toggleShowYearSelection} text={selectedYear.year()} />}
          <div className="flex gap-3 shrink-0">
            <AddOffer callback={updateData} />
          </div>
        </div>
        <div>
          <Forecast />
        </div>
      </div>
      <Modal
        show={showYearSelection}
        onConfirm={updateData}
        onClose={toggleShowYearSelection}
        noClose
        invert
        noForm
        disableClose
        title={t.controlling.yearSelection.title}
      >
        <div className="mt-10">
          <YearSelector value={selectedYear} onChange={setSelectedYear} />
        </div>
      </Modal>
    </LargeContainer>
  )
}

export default YearList
